<template>

  <v-card class="dashboardcontent">    
    <v-card-actions>  
    <v-btn      
      icon
      :to="'/'+$home+'content/pano'"
      >      
      <v-icon>mdi-table-of-contents</v-icon>
    </v-btn>
    </v-card-actions>    

  <v-list-item two-line>
      <v-list-item-icon
        class="dash-icon"
        >
        <v-icon
          size="24"          
          >mdi-panorama-horizontal</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="d-title">
          {{ $t('panoramaic_views') }}
        </v-list-item-title>        
      </v-list-item-content>
    </v-list-item>

  <v-data-table
      v-model="selected"
      :headers="headers"
      :items="panos"
      :footer-props="{
        'disable-items-per-page': true        
      }"      
      :items-per-page="5"
      :single-select="singleSelect"
      :search="search"
      item-key="id"
      class="elevation-1 list-blank"
    >

    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="(item) in items"
          :key="item.id"
        >
          <td>{{ item.id }}</td>
          <td>
            <router-link :to="'/'+$home+'node/pano/' + item.id" text small>
            {{ item.name }}
            </router-link>
            <span style="display:block"><i>{{ item.name_admin }}</i></span>
          </td>            
          <td>
            {{ item.loc_name }}
          </td>                                 
          <td>{{ item.spots.length }}</td>
        </tr>
      </tbody>
    </template>    

  </v-data-table>

  </v-card>
</template>

<script>

import UserContent from '../../helper/UserContent.js';

export default {
  name: 'DashboardPanos',  
  props: ['type'],
  data () {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID',
          align: 'start',
          value: 'id',
          sortable: false
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Ort',
          value: 'loc_name',
        },        
        {
          text: 'POIs',
          value: 'spots',
          width: '80px'
        }
      ],
      panos: [],
      overlaydata: null
    }
  },
  methods: {
      getPanos() {          
          this.axios.get( this.$config.host+"/panos" ).then(response => (
            this.panos = response.data,            
            //console.log("PANOS Data"),
            //console.log(response.data),            
            this.panos = UserContent.getContent(response.data, 'pano')
            //console.log("PANOS Dashboard"),
            //console.log(this.panos)
          ));
      }
  },
  mounted() {        
    this.getPanos();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
